import api from './api'
import type { ProfileSnapshotIn, ShortProfileSnapshotIn } from 'models/ota/ProfileModel'

const PROFILES_RESOURCE = 'profiles'

export const getProfiles = async () => {
  return await api.get<ShortProfileSnapshotIn[]>(`${PROFILES_RESOURCE}/`)
}

export const getProfile = async (profileId: string) => {
  return await api.get<ProfileSnapshotIn>(`${PROFILES_RESOURCE}/${encodeURIComponent(profileId)}/`)
}

export const refreshProfiles = async () => {
  return await api.post(`${PROFILES_RESOURCE}/refresh/`)
}
